<template>
  <div class="layout empty">
    <div
      class="container"
      id="subscribe"
      ref="scrollOnNewCodeElement"
    >
      <section class="main">
        <!-- <div class="girl-container"></div> -->
        <div class="content-container">
          <div class="content">
            <router-link :to="{name: 'home'}">
              <div class="logo"></div>
            </router-link>

            <slot name="purchaseOptions">
              <div class="subscription-container failable loadable loading">
                <div class="loader-wrapper">
                  <Spinner/>
                </div>
              </div>
            </slot>

            <slot name="purchasePromotionCode" />
          </div>

          <div class="support-container">
            <div class="btn" @click="goBackOrHome">
              {{ $t('dashboard.back') }}
            </div>
            <router-link
              class="support-link"
              :to="{name: 'support'}">
              {{ $t('zammad_support.link') }}
            </router-link>
          </div>
        </div>
      </section>

      <slot name="disclaimers"/>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Footer from "../components/Footer";
import Spinner from "../components/Spinner";

export default {
  components: {
    Footer,
    Spinner,
  },
  data() {
    return {
      countries: {
        error: false,
        loading: false,
      },
      purchaseOptions: {
        error: false,
        loading: false,
      },
      fullLoading: false,
    };
  },
  methods: {
    goBackOrHome() {
      if (this.$route.meta.previousRoute) {
        // Si hay una ruta anterior almacenada, redirigimos a ella
        this.$router.push(this.$route.meta.previousRoute);
      } else {
        // Si no hay una ruta anterior almacenada, redirigimos al home
        this.$router.push({ name: 'home' });
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "./../styles/variables";
@import "./../styles/classes";

#subscribe {
  background-color: var(--pallete_dark_color);
  color: var(--pallete_clear_text_color);
  display: flex;
  flex-direction: column;
  padding: 1em;

  .error {
    text-align: center;
  }

  .subscription-container {
    min-height: 400px;
  }

  section.main {
    display: flex;
    justify-content: space-around;
    position: relative;

    .girl-container {
      flex: 1;
      background-image: url("/img/subscribe_girl.png");
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center right;
      z-index: 0;
      max-height: 100vh;
      min-height: 500px;

      @media (max-width: 980px) {
        position: absolute;
        left: -200px;
        width: 400px;
        height: 100%;

        background-position: center center;
      }

      @media (max-width: 600px) {
        left: 0;
        width: 100%;
        height: 100%;
        min-height: auto;
        max-height: inherit;
        background-position: center center;
        opacity: 0.35;
      }
    }

    .content-container {
      position: relative;
      z-index: 1;
      flex: 1.5;
      padding: 20px 0;
      padding-bottom: 0;

      @media (max-width: 980px) {
        padding-left: 20%;
      }

      @media (max-width: 600px) {
        padding-left: 0;
      }

      @media (max-height: 750px) {
        min-height: 100vh;
      }

      .content {
        min-height: 350px;
        width: 500px;
        margin: auto;

        .logo {
          display: block;
          margin: auto;
          height: 50px;
          width: 100%;
          background-image: var(--img-logo);
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center center;
          margin-bottom: 20px;
        }

        @media (max-width: 600px) {
          width: 100%;
          font-size: 0.8em;
        }
      }
    }
  }

  section.features {
    display: flex;
    flex-wrap: wrap;
    margin: 1em 0;
    justify-content: space-around;

    article {
      flex-basis: 25%;

      @media (max-width: 1200px) {
        flex-basis: 30%;
      }

      @media (max-width: 900px) {
        flex-basis: 100%;
      }

      .header {
        background-color: var(--pallete_main_color);
        color: var(--pallete_clear_text_color);
        margin-bottom: 0.5em;
        padding: 0.5em 0.25em;
        text-align: center;
        text-transform: uppercase;
        font-size: 0.9em;
      }

      .image {
        height: 180px;
        background-size: cover;
        background-position: center center;

        @media (max-width: 900px) {
          height: 50vw;
        }
      }
    }
  }

  section.disclaimers {
    display: block;
    text-align: center;
    margin-top: 2em;
    margin-bottom: 2em;

    .logo {
      display: block;
      margin: auto;
      height: 50px;
      width: 100%;
      background-image: var(--img-logo);
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
      margin-bottom: 20px;
    }

    .list {
      font-size: 1em;
      font-weight: bold;
    }
  }

  .promotional-code-form {
    @extend %fresh-btn;
    max-width: 15em;
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    padding: 0.25em 1.5em;
    font-size: 1.5em;
    position: relative;

    label {
      font-size: 0.75em;
    }

    input {
      display: block;
      transition: height 0.33s ease;
      height: 0;
      margin: 0;
      width: 100%;
      text-transform: uppercase;
      color: #ffffff;
      font-size: 1.25em;
      border: none;
      background-color: transparent;

      &.not-empty,
      &:focus {
        outline: none;
        height: 1.25em;
      }
    }
  }
}

.support-container {
  display: flex;
  justify-content: space-evenly;
  text-wrap: balance;
  text-align: center;

  .btn {
    @extend %fresh-btn;

    border-radius: 5px;
  }

  .support-link {
    display: block;
    width: fit-content;
  }
}
</style>
